module.exports = __webpack_public_path__ + "static/drawingsImage-76abedf9fbfd102140071353c5e1bdfa.jpg";